import React, {
  ReactElement, useCallback,
  useState,
} from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput, Paper,
  Select,
  Stack,
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import api from "../../../services/api";
import { LoadingButton } from '@mui/lab';
import toast from 'react-hot-toast';
import {BedtimeRounded, Person, SouthRounded} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


export const OfferRoomCell = ({
                                props,
                                refresh,
                                schema,
                              }: {
  props: any;
  schema: any;
  refresh: () => void;
}): ReactElement => {

  const [open, setOpen] = useState(false);
  const [offers, setOffers] = useState<any>([]);
  const [loadingSendButton, setLoadingSendButton] = useState<any>(false);
  const [loadingButton, setLoadingButton] = useState<any>(false);


  const onSubmit = useCallback(
    async (send?: any) => {
      setLoadingButton(true);

      if (send){

        await api.post(`/accommodation-reservations/${props?.row?.id}/send`, {
          rooms: offers,
          reservation_status: {
            id: 5,
            name: 'Modified',
          },
          schemaColumns: schema?.columns,
        })
          .then((res: any) => {
            setLoadingSendButton(true);
            refresh();
            toast.success('Accommodation reservation has been sent');
          })
          .catch((res: any) => {
            toast.error('Error while sending email');
          })
          .finally(() => {
            setOpen(false);
            setLoadingButton(false);
            setLoadingSendButton(false);
          });
      }else{
        await schema.client.update(props?.row?.id, {
          updated_rooms: offers,
          reservation_status: {
            id: 5,
            name: 'Modified',
          },
          schemaColumns: schema?.columns,
        })
          .then((res: any) => {
            refresh();
            setOpen(false);
            toast.success('Successfully updated reservation');
          })
          .catch((res: any) => {
            refresh();
            toast.success('Error while saving reservation');
          })
          .finally(() => {
            setLoadingButton(false);
            setLoadingSendButton(false);
          });
      }


    },
    [offers, schema]
  );

  console.log(props?.row);

  return (
    <>

      <Button
        variant="text"
        onClick={(event) => {
          setOpen(true);
          setOffers(props?.row?.room_offers);
        }}
      >
        VIEW OFFER
      </Button>

      {open && (
        <>
          <Dialog
            sx={{
              '& .MuiPaper-root': {
                width: {
                  md: 'auto',
                  lg: 'auto',
                },
                minWidth: {
                  md: '600px',
                  lg: '600px',
                },

                maxWidth: {
                  md: 'calc(100vw - 400px)',
                  lg: 'calc(100vw - 400px)',
                },
              },
            }}
            open={true} onClose={() => {
            setOpen(false);
          }}>
            <DialogTitle>{props?.row?.accommodation?.name} / Room offers - {props?.row?.group?.name} </DialogTitle>
            <DialogContent>

              <Stack gap={1}>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={3}>
                    <Item>
                      <Stack alignItems={'center'} gap={1} direction={'row'}>
                        <BedtimeRounded fontSize={'small'} color={'primary'} />
                        <Typography variant={'body2'}>{props?.row?.arrival} - {props?.row?.departure}</Typography>
                        <Typography variant={'body2'}>( <b>{props?.row?.number_of_nights || '-'} nights</b> )</Typography>
                      </Stack>
                    </Item>
                  </Grid>
                </Grid>

                {props?.row?.original_rooms.length && (
                  <>
                    <List sx={{
                      width: "100%", bgcolor: "#efefef", borderRadius: '10px',
                      '& .MuiListItem-root': {
                        bgcolor: "transparent"
                      }
                    }}>
                      {props?.row?.original_rooms.map((room:any, index:any) => (
                        <ListItem
                          key={room.id}
                          sx={{
                            background: "#f6f6f6",
                            borderRadius: "5px",
                            mb: 0.5,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Stack gap={"6px"} direction={"row"} alignItems="flex-start">
                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-size-${room.id}`}>Szoba Típusa</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-type-${room.id}`}
                                    label="Szoba Típusa"
                                    value={room?.room_type?.name}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Person />
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-size-${room.id}`}>Férőhely</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-size-${room.id}`}
                                    label="Férőhely"
                                    value={room.room_size}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Person />
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-qty-${room.id}`}>Darabszám</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-qty-${room.id}`}
                                    label="Darabszám"
                                    value={room.quantity}
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-price-${room.id}`}>Ár</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    id={`room-price-${room.id}`}
                                    label="Ár"
                                    value={room.price_per_night}
                                    sx={{ background: "#fefefe" }}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Select
                                          disabled={true}
                                          value={room.currency}
                                          variant="standard"
                                          disableUnderline
                                          sx={{ minWidth: 20, ml: 1, fontSize: "0.9rem" }}
                                        >
                                          <MenuItem value="1">€</MenuItem>
                                          <MenuItem value="2">Ft</MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Stack>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}

                <Stack
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                 <SouthRounded
                   color={'error'}
                   fontSize={'small'}
                 sx={{
                   bgcolor: "#e5e5e5",
                   borderRadius: '50px'
                 }}
                 />
                </Stack>

                {offers.length && (
                  <>
                    <List sx={{
                      width: "100%", bgcolor: "#efefef", borderRadius: '10px',
                      '& .MuiListItem-root': {
                        bgcolor: "transparent"
                      }
                    }}>
                      {offers.map((room:any) => (
                        <ListItem
                          key={room._key}
                          sx={{
                            background: "#f6f6f6",
                            borderRadius: "5px",
                            mb: 0.5,
                          }}
                        >
                          <ListItemText
                            primary={
                              <Stack gap={"6px"} direction={"row"} alignItems="flex-start">
                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-size-${room._key}`}>Szoba Típusa</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-type-${room._key}`}
                                    label="Szoba Típusa"
                                    value={room.room_type}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Person />
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-size-${room._key}`}>Férőhely</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-size-${room._key}`}
                                    label="Férőhely"
                                    value={room.room_size}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Person />
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-qty-${room._key}`}>Darabszám</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    sx={{ background: "#fefefe" }}
                                    id={`room-qty-${room._key}`}
                                    label="Darabszám"
                                    value={room.quantity}
                                  />
                                </FormControl>

                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor={`room-price-${room._key}`}>Ár</InputLabel>
                                  <OutlinedInput
                                    disabled={true}
                                    id={`room-price-${room._key}`}
                                    label="Ár"
                                    value={room.price_per_night}
                                    sx={{ background: "#fefefe" }}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <Select
                                          disabled={true}
                                          value={room.currency}
                                          variant="standard"
                                          disableUnderline
                                          sx={{ minWidth: 20, ml: 1, fontSize: "0.9rem" }}
                                        >
                                          <MenuItem value="1">€</MenuItem>
                                          <MenuItem value="2">Ft</MenuItem>
                                        </Select>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Stack>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
              </Stack>

            </DialogContent>
            <DialogActions>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={() => {
                  onSubmit();
                }}
                autoFocus
                loading={loadingSendButton || loadingButton}
              >
                Save
              </LoadingButton>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={() => {
                  onSubmit(true);
                }}
                autoFocus
                loading={loadingSendButton || loadingButton}
              >
                Save and Send to Provider
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </>
      )}

    </>
  );
};
